import { useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	RETIREMENT_DROP_NOTE_COPY,
	RETIREMENT_LOAN_KIND_COPY,
	RetirementDropSource,
} from "web_myplann/Inspiration/Retirement/constants";
import type {
	RetirementDrop,
	RetirementDropLabel,
	RetirementDropNote,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.Retirement;

export const useRetirementDropRow = (drop: RetirementDrop) => {
	const { t } = useResource();
	const theme = useTheme();

	const label = (value: RetirementDropLabel): string => {
		if (value.type === RetirementDropSource.Portfolio) return value.name;
		if (value.type === RetirementDropSource.Savings)
			return t(R.expensesSavingsLabel);
		return t(RETIREMENT_LOAN_KIND_COPY[value.kind]);
	};

	const note = (value: RetirementDropNote): string =>
		t(RETIREMENT_DROP_NOTE_COPY[value.type], {
			year: "year" in value ? value.year : undefined,
		});

	return {
		label: label(drop.label),
		note: note(drop.note),
		amount: `${drop.checked ? "− " : ""}${formatInspirationMoney(drop.amount)}`,
		removeLabel: t(R.expensesRemoveLoan),
		isManual: drop.label.type === RetirementDropSource.Manual,
		textColor: drop.checked ? theme.palette.grey[900] : theme.palette.grey[500],
		amountColor: drop.checked
			? theme.palette.green.main
			: theme.palette.grey[500],
	};
};
